import useServiceStatus from "../../../hooks/useServiceStatus";
import TradeButton from "../../../shared/trade-form/TradeButton";
import styles from "../../../styles/Components/new-insight/signals-section/signals-table/PlaceOrderButton.module.css";
import HiddenContent from "../../../ui/HiddenContent";
import useInsightOverallSignal from "../../../hooks/useInsightOverallSignal";

function PlaceOrderButton({ coin }) {
  const { isActive } = useServiceStatus("insight");

  const { finalSuggestion } = useInsightOverallSignal(coin);

  if (!isActive) return <HiddenContent service="insai" />;
  if (!finalSuggestion) return <span>-</span>;

  return (
    <TradeButton
      data={{ coin }}
      btnClassName={`${styles?.[finalSuggestion?.toLowerCase()]} ${styles.btn}`}
    >
      {finalSuggestion}
    </TradeButton>
  );
}

export default PlaceOrderButton;
